import utilParties from "../modules/utilParties";

function getValueRow(className, data, increase, type = "%") {
  return `<td class="c-table__td ${className} ${
    increase !== null ? utilParties.getTendencyClass(increase) : ""
  }">${data}${type}</td>`;
}

function getRow(className, voting, type, increase = null) {
  switch (type) {
    case "electors": {
      return getValueRow(
        className,
        voting.votes.toLocaleString('de'),
        increase,
        ""
      );
    }
    case "participation":
      return getValueRow(className, voting.votesPct.toFixed(2).replaceAll(".", ","), increase);
    case "blanks":
      return getValueRow(className, voting.blanksPct.toFixed(2).replaceAll(".", ","), increase);
    case "nulls":
      return getValueRow(className, voting.voidedPct.toFixed(2).replaceAll(".", ","), increase);
    default:
      return getValueRow(className, "--", "", increase);
  }
}

function populateTables(currentVoting, previousVoting) {
  const votingTableBlanks = document.querySelector(".js-scrutiny-table-blanks");
  const votingTableInvolvement = document.querySelector(
    ".js-scrutiny-table-involvement"
  );

  let increaseElectors = null;
  let increaseParticipation = null;
  let increaseBlanks = null;
  let increaseNulls = null;

  // show data for current election, checking the status of the data before, if is waiting, we show -- instead of data
  if (currentVoting.time !== "--:--") {
    increaseElectors = utilParties.hasIncrease(
      previousVoting.votes,
      currentVoting.votes
    );
    increaseParticipation = utilParties.hasIncrease(
      previousVoting.votesPct,
      currentVoting.votesPct
    );
    increaseBlanks = utilParties.hasIncrease(
      previousVoting.blanksPct,
      currentVoting.blanksPct
    );
    increaseNulls = utilParties.hasIncrease(
      previousVoting.voidedPct,
      currentVoting.voidedPct
    );
  }

  votingTableInvolvement
    .querySelector(".js-electors")
    .insertAdjacentHTML(
      "beforeend",
      getRow("current", currentVoting, "electors", increaseElectors)
    );
  votingTableInvolvement
    .querySelector(".js-participation")
    .insertAdjacentHTML(
      "beforeend",
      getRow("current", currentVoting, "participation", increaseParticipation)
    );

  votingTableBlanks
    .querySelector(".js-blanks")
    .insertAdjacentHTML(
      "beforeend",
      getRow("current", currentVoting, "blanks", increaseBlanks)
    );
  votingTableBlanks
    .querySelector(".js-nulls")
    .insertAdjacentHTML(
      "beforeend",
      getRow("current", currentVoting, "nulls", increaseNulls)
    );

  // show data for previous election
  votingTableInvolvement
    .querySelector(".js-electors")
    .insertAdjacentHTML(
      "beforeend",
      getRow("previous", previousVoting, "electors")
    );
  votingTableInvolvement
    .querySelector(".js-participation")
    .insertAdjacentHTML(
      "beforeend",
      getRow("previous", previousVoting, "participation")
    );

  votingTableBlanks
    .querySelector(".js-blanks")
    .insertAdjacentHTML(
      "beforeend",
      getRow("previous", previousVoting, "blanks")
    );
  votingTableBlanks
    .querySelector(".js-nulls")
    .insertAdjacentHTML(
      "beforeend",
      getRow("previous", previousVoting, "nulls")
    );

  votingTableInvolvement.classList.remove("hide");
  votingTableBlanks.classList.remove("hide");
}

function drawDataTable() {
  window.dataManager.getVoting().then((currentVoting) => {
    if (currentVoting) {
      window.dataManager.getHistoricVoting().then((previousVoting) => {
        if (previousVoting) {
          populateTables(currentVoting, previousVoting);
        }
      });
    }
  });
}

function init() {
  if (document.querySelector('[data-controller*="ac-scrutiny-table"]')) {
    drawDataTable();
  }
}

export default init;
